import { BaseModel } from '../common/base-model/base-model';

export class Service extends BaseModel {
  constructor(
    public override id?: string,
    public name?: string,
    public description?: string,
    public acronym?: string,
    public color?: string,
    public isActive?: boolean,
    public scheduling_duration_minutes?: number,
    public parent_service_id?: string,
    public owner_root_entity_id?: string,
    public target_entity_id?: string,
    public software_id?: string | null,
    public slug_software?: string | null,
    public source_service_id?: string | null,
  ) {
    super();
  }

  static fromJson(jsonData: any): Service {
    const service = Object.assign(new Service(), jsonData);

    if (
      jsonData.scheduling_duration_minutes !== null &&
      jsonData.scheduling_duration_minutes !== undefined &&
      jsonData.scheduling_duration_minutes !== ''
    ) {
      service.scheduling_duration_minutes = Number(
        jsonData.scheduling_duration_minutes,
      );
    } else {
      service.scheduling_duration_minutes = 30;
    }

    if (
      jsonData.parent_service_id !== null &&
      jsonData.parent_service_id !== undefined &&
      jsonData.parent_service_id !== ''
    ) {
      service.parent_service_id = jsonData.parent_service_id;
    } else {
      service.parent_service_id = null;
    }

    if (jsonData.isActive !== undefined) {
      service.isActive =
        jsonData.isActive === 1 ||
        jsonData.isActive === true ||
        jsonData.isActive === 'true';
    }

    return service;
  }
}
